import { Award, BarChart3, BookOpen, CalendarRange, History, Home, Mic, Sparkles, Trophy, UserRound } from 'lucide-react'
import { NavLink, Outlet } from 'react-router-dom'
import { AccountMenu } from '@/components/shell/AccountMenu'
import { Brand } from '@/components/shell/Brand'
import { HeaderSearch } from '@/components/shell/HeaderSearch'
import { useAuth } from '@/features/auth/auth-context'
import { NotificationsBell } from '@/features/notifications/NotificationsBell'
import { cn } from '@/lib/cn'

// Lucent navigation vocabulary (DESIGN-BRIEF: Focus · Practice · Evidence ·
// Plan) mapped onto the real, unrenamed routes; the remaining product surfaces
// keep their own entries.
const nav = [
  { to: '/home', label: 'Focus', icon: Home },
  { to: '/exams-library', label: 'Practice', icon: BookOpen },
  { to: '/keep-talking', label: 'Keep Talking', icon: Mic },
  { to: '/my-exams', label: 'Attempts', icon: History },
  { to: '/leaderboard', label: 'Community', icon: Trophy },
  { to: '/achievements', label: 'Achievements', icon: Award },
  { to: '/results', label: 'Evidence', icon: BarChart3 },
  { to: '/plan', label: 'Plan', icon: CalendarRange },
]

const mobileNav = nav.filter(({ label }) => ['Focus', 'Practice', 'Keep Talking', 'Evidence'].includes(label))

export function LucentShell() {
  const { demo } = useAuth()
  return (
    <div className="lucent-shell">
      <header className="product-header">
        <Brand />
        <nav aria-label="Primary navigation">
          {nav.map(({ to, label }) => (
            <NavLink key={to} to={to} className={({ isActive }) => cn(isActive && 'active')}>
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="product-header__actions">
          <HeaderSearch />
          {demo && <span className="demo-chip"><Sparkles size={13} /> Sample journal · nothing is saved</span>}
          <NotificationsBell />
          {/* Profile and sign out both live behind the avatar. Two sign-out
              affordances a few pixels apart is how one of them gets clicked by
              accident, and an unlabelled icon is how neither gets found. */}
          <AccountMenu />
        </div>
      </header>
      <main className="product-main"><Outlet /></main>
      <nav className="product-dock" aria-label="Mobile navigation">
        {mobileNav.map(({ to, label, icon: Icon }) => (
          <NavLink key={to} to={to} className={({ isActive }) => cn(isActive && 'active')}>
            <Icon size={18} /><span>{label}</span>
          </NavLink>
        ))}
        <NavLink to="/profile"><UserRound size={18} /><span>Profile</span></NavLink>
      </nav>
    </div>
  )
}
